import React, { useCallback, useEffect, useState } from 'react';
import api from '../../api/axios';
import './ApprovalRecoveryBanner.css';

const COPY = {
  initializing: {
    title: 'Approval-herstel wordt gestart',
    body: 'De veilige uitvoeringscontrole initialiseert. Voorstellen blijven geblokkeerd totdat de status bekend is.',
  },
  recovering: {
    title: 'Approval-uitvoering wordt veilig hersteld',
    body: 'Een of meer goedgekeurde acties staan tijdelijk op hold terwijl Leadgenflow de approval- en uitvoeringsstatus controleert.',
  },
  degraded: {
    title: 'Approval-herstel heeft aandacht nodig',
    body: 'Leadgenflow ziet verlopen approvals of een recovery-worker die niet recent genoeg heeft gedraaid. Acties blijven fail-closed geblokkeerd.',
  },
  disabled: {
    title: 'Approval-herstel staat uit',
    body: 'Automatisch herstel van onderbroken approvals is uitgeschakeld. Approval-acties blijven wel door de execution guards beschermd.',
  },
};

function ApprovalRecoveryBanner({ refreshMs = 15000 }) {
  const [status, setStatus] = useState(null);

  const load = useCallback(async () => {
    try {
      const response = await api.get('/operations/approval-recovery');
      setStatus(response.data?.approvalRecovery || null);
    } catch (error) {
      // Approval-recovery observability must never block the approval queue itself.
    }
  }, []);

  useEffect(() => {
    load();
    const handle = window.setInterval(load, refreshMs);
    return () => window.clearInterval(handle);
  }, [load, refreshMs]);

  const health = status?.health?.status;
  if (!health || health === 'healthy') return null;

  const copy = COPY[health] || COPY.degraded;
  const held = Number(status?.counts?.approvalHold || 0);
  const expired = Number(status?.counts?.expiredApprovals || 0);
  const lastRun = status?.worker?.lastRun?.completedAt;

  return (
    <section className={`approval-recovery-banner approval-recovery-banner-${health}`} role={health === 'degraded' ? 'alert' : 'status'}>
      <div>
        <strong>{copy.title}</strong>
        <p>{copy.body}</p>
      </div>
      <div className="approval-recovery-metrics" aria-label="Approval-herstelstatus">
        {held > 0 && <span>{held} op hold</span>}
        {expired > 0 && <span>{expired} verlopen</span>}
        {lastRun && <span>Laatste check {new Date(lastRun).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>}
      </div>
    </section>
  );
}

export default ApprovalRecoveryBanner;
